import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);
import Api from "../http/api";
import { Message } from "element-ui";

export default new Vuex.Store({
  state: {
    user: {
      id: "",
      name: "",
      role: [],
      token: "",
      phone: "",
    },
    count: 0,
    changeOpen: false,
  },
  mutations: {
    setToken(state) {
      const token = localStorage.getItem("token");

      if (!token) {
        Message({
          showClose: true,
          message: "用户未登录",
          type: "error",
        });

        window.location.href = "/login";
      }
      state.user.token = token;
    },
    setUserInfo(state, user) {
      const name = localStorage.getItem("name");
      const userId = localStorage.getItem("userId");
      const role = localStorage.getItem("role");
      const phone = localStorage.getItem("phone");

      state.user.name = name;
      state.user.id = userId;
      state.user.role = role;
      state.user.phone = phone;
    },
    setCount(state, count) {
      state.count = count;
    },
    setChangeOpen(state, visible) {
      state.changeOpen = visible;
    },
  },
  actions: {
    async autoLogin({ commit }) {
      try {
        const localToken = window.localStorage.getItem("token");
        if (!localToken) {
          window.location.href = "/login";
          return;
        }
        const res = await Api.Account.login({
          type: "resume",
          payload: {
            token: localToken,
          },
        });

        if (res.error) {
          this.$message.error("用户未登录");
          window.location.href = "/login";
          return;
        }
        const { token, user } = res.data;
        localStorage.setItem("token", token);
        localStorage.setItem("userId", user.id);
        localStorage.setItem("name", user.name);
        localStorage.setItem("phone", user.phone && user.phone.number);
        localStorage.setItem("role", user.role);

        commit("setToken");
        commit("setUserInfo");
      } catch (err) {
        console.log(err);
        window.location.href = "/login";
      }
    },
    setUser({ commit }) {
      commit("setUserInfo");
    },
    setToken({ commit }) {
      commit("setToken");
    },
    async setCount({ commit }, payload) {
      try {
        const { data, error } = await Api.Account.getWordsCount();
        if (error) {
          commit("setCount", 0);
        }

        commit("setCount", data.word || 0);
      } catch (error) {
        console.log(error, "error");
      }
    },
    setChangeOpen({ commit }, payload) {
      commit("setChangeOpen", payload);
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js